import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

import banner from '../assets/images/nails.jpg';
import bannerHome from '../assets/images/home-banner.png';
import homeCard from '../assets/images/home-card.png';
import serviceCard from '../assets/images/service-image.png';
import carruselCenter from '../assets/images/carrusel-center.png';
import carruselRight from '../assets/images/carrusel-image.png';
import imagen1 from '../assets/images/trabajo1.jpeg';
import imagen2 from '../assets/images/trabajo2.jpeg';
import imagen3 from '../assets/images/trabajo3.jpeg';
import imagen4 from '../assets/images/trabajo4.jpeg';
import imagen5 from '../assets/images/trabajo5.jpeg';

import Layout from "../components/Layout";
import '../styles/Home.css';

const BACKEND_URL = "https://api.comprapapaya.com";

function Home() {
  const navigate = useNavigate();

  const services = [
    { name: "Uñas Postizas", price: "s/70.00", image: carruselRight },
    { name: "Uñas Acrílicas", price: "s/70.00", image: serviceCard },
    { name: "Manicure Semi", price: "s/70.00", image: carruselCenter },
    { name: "Diseño Premium", price: "s/70.00", image: carruselRight }
  ];

  const carouselImages = [
    imagen1,
    imagen2,
    imagen3,
    imagen4,
    imagen5
  ];

  const [currentSlide, setCurrentSlide] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [reviews, setReviews] = useState([]);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1100);

  const extendedImages = [
    carouselImages[carouselImages.length - 1],
    ...carouselImages,
    carouselImages[0]
  ];

  const prevSlide = () => {
    if (!isTransitioning) return;
    setCurrentSlide((prev) => prev - 1);
  };

  const nextSlide = () => {
    if (!isTransitioning) return;
    setCurrentSlide((prev) => prev + 1);
  };

  useEffect(() => {
    if (currentSlide === 0) {
      setTimeout(() => {
        setIsTransitioning(false);
        setCurrentSlide(carouselImages.length);
      }, 500);
    } else if (currentSlide === extendedImages.length - 1) {
      setTimeout(() => {
        setIsTransitioning(false);
        setCurrentSlide(1);
      }, 500);
    }
  }, [currentSlide, carouselImages.length, extendedImages.length]);

  useEffect(() => {
    if (!isTransitioning) {
      setTimeout(() => {
        setIsTransitioning(true);
      }, 50);
    }
  }, [isTransitioning]);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1100);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    axios
      .get(`${BACKEND_URL}/reviews/public`)
      .then((res) => {
        setReviews(res.data);
      })
      .catch((err) => {
        console.error("Error cargando reseñas:", err);
      });
  }, []);

  return (
    <>
      <Layout>
        <div className="home-container">

          {/* Hero Section */}
          <section
            className="home-hero"
            style={{ backgroundImage: `url(${bannerHome})` }}
          >
            <div className="home-hero-overlay">
              <div className="home-hero-content">
                <h2 className="home-hero-title">
                  REALZA LA BELLEZA<br />
                  DE TUS MANOS
                </h2>
                <p className="home-hero-subtitle">
                  Descubre nuestros servicios de<br />
                  manicure y diseño de uñas.
                </p>
                <button
                  className="home-cta-button"
                  onClick={() => navigate('/services')}
                >
                  AGENDA TU CITA
                </button>
              </div>
            </div>
          </section>

          {/* About Section */}
          <section className="home-about" id="nosotros">
            <div className="home-about-content">
              <h2>NOSOTROS</h2>
              <p>
                En Emilia Nail Studio nos especializamos en el cuidado y
                embellecimiento de tus manos. Nuestro equipo de profesionales
                certificadas trabaja con las mejores técnicas y productos
                para brindarte un servicio de calidad excepcional.
              </p>

              <div className="home-about-features">
                <div className="home-feature-card">
                  <h3>Experiencia</h3>
                  <p>Más de 5 años en el mercado</p>
                </div>
                <div className="home-feature-card">
                  <h3>Calidad</h3>
                  <p>Productos premium certificados</p>
                </div>
                <div className="home-feature-card">
                  <h3>Profesionales</h3>
                  <p>Personal altamente capacitado</p>
                </div>
                <div className="home-feature-card">
                  <h3>Higiene</h3>
                  <p>Estándares sanitarios estrictos</p>
                </div>
              </div>
            </div>

            <div className="home-about-image">
              <img src={homeCard} alt="Profesional de Valentina Nails" />
            </div>
          </section>

          {/* Services Section */}
          <section className="home-services" id="servicios">
            <h2>NUESTROS SERVICIOS</h2>
            <p className="home-services-subtitle">
              Embellece tus uñas con nuestros servicios profesionales
            </p>

            <div className="home-services-grid">
              {services.map((service, index) => (
                <div key={index} className="home-service-card">
                  <div className="home-service-image">
                    <img src={service.image} alt={service.name} />
                  </div>
                  <div className="home-service-info">
                    <h3>{service.name}</h3>
                    <p className="home-service-price">{service.price}</p>
                  </div>
                </div>
              ))}
            </div>

            <button
              className="home-cta-button-secondary"
              onClick={() => navigate('/services')}
            >
              AGENDA TU CITA
            </button>
          </section>

          {/* Gallery Section */}
          <section className="home-gallery">
            <div className="carousel-container">
              <div
                className="carousel-track"
                style={{
                  transform: isDesktop
                    ? `translateX(calc(-${currentSlide} * (var(--slide-width, 30%) + var(--gap, 30px)) + var(--offset, 5%)))`
                    : `translateX(-${currentSlide * 100}%)`,
                  transition: isTransitioning
                    ? 'transform 0.8s cubic-bezier(0.23, 1, 0.32, 1)'
                    : 'none'
                }}
              >
                {extendedImages.map((image, index) => {
                  const isActive = isDesktop
                    ? index === currentSlide + 1
                    : index === currentSlide;

                  return (
                    <div
                      key={index}
                      className={`carousel-slide ${isActive ? 'is-active' : ''}`}
                    >
                      <img src={image} alt={`Trabajo ${index + 1}`} />
                    </div>
                  );
                })}
              </div>

              <div className="carousel-controls">
                <button
                  className="carousel-btn carousel-btn-prev"
                  onClick={prevSlide}
                  aria-label="Anterior"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M15 18l-6-6 6-6" />
                  </svg>
                </button>

                <button
                  className="carousel-btn carousel-btn-next"
                  onClick={nextSlide}
                  aria-label="Siguiente"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </button>
              </div>
            </div>
          </section>

          {/* Reviews Section */}
          <section className="home-reviews">
            <h2>LO QUE NUESTROS CLIENTES DICEN</h2>

            {reviews.length > 0 && (
              <div className="reviews-carousel">
                <div className="reviews-track">
                  {[...reviews, ...reviews].map((r, index) => (
                    <div key={index} className="review-card">
                      <h4>{r.name}</h4>
                      <div className="review-stars">
                        {'★'.repeat(r.rating)}
                      </div>
                      <p>{r.comment}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </section>

        </div>
      </Layout>
    </>
  );
}

export default Home;